import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from './SharedUserDrawer';
import logo5 from "../logo5.png"
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import { PatientHeaderContent } from "../../Landingpagecomponents/Header/headerPatient.js";
import ChartProgress from "./data/overview_data.js/ChartProgress.js";
import FollowUpAssessment from "../../Assessment/questionaire_follow_up";
import WeeklyGoal from './data/overview_data.js/WeeklyGoal';
import Endurance from './data/overview_data.js/Endurance';
import Strength from './data/overview_data.js/Strength';
import PainReport from './data/overview_data.js/Painreport'
import FocusOfPlan from './data/overview_data.js/FocusOfPlan';
import MobilityTrack from './data/overview_data.js/MobilityTrack';
import PatientJourney from './data/overview_data.js/patientJourney';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright � '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

//logout
  //
  //

const drawerWidth = 223;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
    minHeight: '50px !important',
    maxHeight: 50,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 50,
    maxHeight: 50,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginTop: 2,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 250,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 250,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_LG,
    width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
    [theme.breakpoints.up('xl')]: {
      marginLeft: DRAWER_WIDTH_XL,
      width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    maxWidth: "100%",
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  containerEmbedded: {
    paddingTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

export default function Overview() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))

  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector(state => state.auth.token);
  const embeddedWorkspace = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('embedded') === '1';

  // Shared phase/session state for child components
  const [completedSessionsList, setCompletedSessionsList] = useState([]);
  const [phaseProgress, setPhaseProgress] = useState(null);
  const [phaseProgressDisplay, setPhaseProgressDisplay] = useState(null);
  const [phaseTitle, setPhaseTitle] = useState('');
  // phase plan details (provided by sessions API): per-phase planned sessions/day
  const [phasePlans, setPhasePlans] = useState([]);
  // overall planned sessions per day (numeric) derived server-side
  const [plannedSessionsPerDayOverall, setPlannedSessionsPerDayOverall] = useState(null);
  // improvements fetched from backend for current diagnosis
  const [improvements, setImprovements] = useState(null);
  // baseline selfRatedPain items
  const [baselineSelfRated, setBaselineSelfRated] = useState(null);
  // baseline selfRatedFunction items
  const [baselineSelfFunction, setBaselineSelfFunction] = useState(null);
  // clinician-added KPI items (pain baselines + function goals) from journal versions
  const [clinicianKpis, setClinicianKpis] = useState([]);
  const [kpiHistory, setKpiHistory] = useState({});
  // When true, show the follow-up questionnaire in-place (no popover / no chart background)
  const searchParams = new URLSearchParams(window.location.search);
  const initialShowFollowup = searchParams.get('showFollowup') === 'true';
  const [showFollowup, setShowFollowup] = useState(initialShowFollowup);
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [treatments, setTreatments] = useState([]);

  // Fetch treatments on mount
  useEffect(() => {
    const fetchTreatments = async () => {
      if (!token) return;
      try {
        const res = await fetch('https://api.virtus-one.com/treatment/user/treatments/', {
          headers: { 'Authorization': `Token ${token}` },
          method: 'GET',
        });
        if (res.ok) {
          const data = await res.json();
          setTreatments(data);
          const saved = localStorage.getItem('vp_selectedTreatmentId');
          const defaultTreatment = saved && data.find(t => t.id === saved) ? saved : (data[0]?.id || null);
          setSelectedTreatmentId(defaultTreatment);
        }
      } catch (err) {
        console.error('Failed to fetch treatments', err);
      }
    };
    fetchTreatments();
  }, [token]);

  // Fetch all data when selectedTreatmentId changes
  useEffect(() => {
    if (!token || !selectedTreatmentId) return undefined;

    let active = true;
    const controller = new AbortController();
    const requestOptions = {
      headers: { 'Authorization': `Token ${token}` },
      method: 'GET',
      signal: controller.signal,
    };

    // Parent-owned state survives the keyed child remount below, so clear it
    // while the newly selected treatment is loading.
    setCompletedSessionsList([]);
    setPhaseProgress(null);
    setPhaseProgressDisplay(null);
    setPhaseTitle('');
    setPhasePlans([]);
    setPlannedSessionsPerDayOverall(null);
    setImprovements(null);
    setBaselineSelfRated(null);
    setBaselineSelfFunction(null);
    setClinicianKpis([]);
    setKpiHistory({});

    const fetchAll = async () => {
      try {
        const phaseRes = await fetch(
          `https://api.virtus-one.com/treatment/phase/progress/treatment/${selectedTreatmentId}/`,
          requestOptions,
        );
        if (phaseRes.ok) {
          const phaseData = await phaseRes.json();
          if (!active) return;
          setPhaseProgress(phaseData.progress);
          setPhaseTitle(phaseData.name);
          setPhaseProgressDisplay(phaseData.progress_display || null);
        }

        const allSessionsRes = await fetch(
          `https://api.virtus-one.com/treatment/sessions/all/treatment/${selectedTreatmentId}/`,
          requestOptions,
        );
        if (allSessionsRes.ok) {
          const allSessionsData = await allSessionsRes.json();
          if (!active) return;
          const mappedSessions = (allSessionsData.sessions || []).map(session => ({
            id: session.id,
            completed_date: session.completed_date,
            phase: session.phase,
            phase_index: session.phase_index,
            exercise_feedback: session.exercise_feedback,
            session_feedback: session.session_feedback,
          }));
          setCompletedSessionsList(mappedSessions);
          if (allSessionsData.phase_plans) setPhasePlans(allSessionsData.phase_plans);
          if (typeof allSessionsData.planned_sessions_per_day_overall !== 'undefined') setPlannedSessionsPerDayOverall(allSessionsData.planned_sessions_per_day_overall);
        }

        // Get diagnosis from treatment to fetch improvements
        const treatment = treatments.find(t => t.id === selectedTreatmentId);
        if (treatment && treatment.diagnosis_identifier) {
          try {
            const impRes = await fetch(
              `https://api.virtus-one.com/question-handler/improvements/${treatment.diagnosis_identifier}/`,
              requestOptions,
            );
            if (impRes.ok) {
              const impJson = await impRes.json();
              if (!active) return;
              setImprovements(impJson);
            }
          } catch (err) {}

          try {
            const baseRes = await fetch(
              `https://api.virtus-one.com/question-handler/baseline/${treatment.diagnosis_identifier}/?qtypes=selfRatedPain,selfRatedFunction`,
              requestOptions,
            );
            if (baseRes.ok) {
              const baseJson = await baseRes.json();
              if (!active) return;
              // response.baselines is a map keyed by questionType
              const baselines = baseJson && baseJson.baselines ? baseJson.baselines : {};
              setBaselineSelfRated(baselines.selfRatedPain || null);
              setBaselineSelfFunction(baselines.selfRatedFunction || null);
            }
          } catch (err) {}
        }

        // Fetch clinician-added KPI items for this treatment
        try {
          const kpiRes = await fetch(
            `https://api.virtus-one.com/treatment/treatments/${selectedTreatmentId}/kpi_items/?in_latest_journal=1`,
            requestOptions,
          );
          if (kpiRes.ok) {
            const kpiJson = await kpiRes.json();
            if (!active) return;
            setClinicianKpis(kpiJson.kpi_items || []);
          }
        } catch (err) {}

        // Fetch KPI history for chart time series
        if (treatment && treatment.diagnosis_identifier) {
          try {
            const kpiHistRes = await fetch(
              `https://api.virtus-one.com/question-handler/kpi-history/${treatment.diagnosis_identifier}/`,
              requestOptions,
            );
            if (kpiHistRes.ok) {
              const kpiHistJson = await kpiHistRes.json();
              if (!active) return;
              setKpiHistory(kpiHistJson || {});
            }
          } catch (err) {}
        }
    } catch (err) {}
    };

    fetchAll();

    return () => {
      active = false;
      controller.abort();
    };
  }, [token, selectedTreatmentId, treatments]);

  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };
//virker ovenst�ende som forventet?

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const journeyRef = useRef(null);
  const handleScrollToJourney = () => {
    if (journeyRef.current) {
      journeyRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  // Security check: verify authentication before rendering
  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting...</div>;
  }
  
  if (isLoggedIn) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        {!embeddedWorkspace ? (
          <>
            <AppBar style={{ color: "#002D55", backgroundColor: "#FFFFFF" }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
              <Toolbar className={classes.toolbar}>
                <PatientHeaderContent
                  onLogout={handleClickLogout}
                  onProfile={() => history.push('/myaccount?tab=profile')}
                  onOpenVideo={() => {}}
                  onOpenCheckin={() => {}}
                  onTreatmentChange={(treatment) => setSelectedTreatmentId(treatment.id)}
                />
              </Toolbar>
            </AppBar>
            <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
          </>
        ) : null}
        <main className={classes.content} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}>
          {!embeddedWorkspace ? <div className={classes.appBarSpacer} /> : null}
          <Container key={selectedTreatmentId} maxWidth={false} className={clsx(classes.container, embeddedWorkspace && classes.containerEmbedded)} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}>
            <Grid container spacing={0}>
                {showFollowup ? (
                  // Render the follow-up questionnaire in-place without duplicating header/sidebar
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <FollowUpAssessment showShell={false} />
                  </Grid>
                ) : (
                  <Grid container spacing={1} xs={12} md={12} lg={12} xl={12}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <ChartProgress
                        phaseProgress={phaseProgress}
                        phaseProgressDisplay={phaseProgressDisplay}
                        phaseTitle={phaseTitle}
                        completedSessionsList={completedSessionsList}
                        phase_plans={phasePlans}
                        planned_sessions_per_day_overall={plannedSessionsPerDayOverall}
                        onStartFollowup={() => { window.location.href = '/FollowUpAssessment_questionaire'; }}
                        improvements={clinicianKpis.length ? improvements : null}
                        baselineSelfRated={clinicianKpis.length ? baselineSelfRated : null}
                        baselineSelfFunction={clinicianKpis.length ? baselineSelfFunction : null}
                        clinicianKpis={clinicianKpis}
                        treatmentId={selectedTreatmentId}
                        kpiHistory={clinicianKpis.length ? kpiHistory : {}}
                        onScrollToJourney={handleScrollToJourney}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12} ref={journeyRef}>
                      <PatientJourney
                        progress={phaseProgress}
                        title={phaseTitle}
                        completedSessionsList={completedSessionsList}
                        planned_sessions_per_day_overall={plannedSessionsPerDayOverall}
                        plannedSessionsPerDay={plannedSessionsPerDayOverall}
                        treatmentId={selectedTreatmentId}
                      />  
                    </Grid>
                  </Grid>
                )}
            </Grid>
            <Box pt={2}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  } else {
    return <div>Unauthorized</div>;
  }
}
